"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCompatTag;

function isCompatTag(tagName) {
  return !!tagName && /^[a-z]/.test(tagName);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/types/lib/validators/react/isCompatTag.js
// module id = 4gdG
// module chunks = 0